import { useTranslation } from 'react-i18next';
import { S, Icon, Icons, StatusBadge, BtnPrimary } from '../../regureStyles';
import useConfirm from '../../../components/ConfirmDialog/useConfirm';

const Header = ({b, setSelectedBroker, setShowAddForm, setNewBroker, onDelete }) => {
  const { t } = useTranslation();
  const { confirm, ConfirmPortal } = useConfirm();
  // D-14: delete affordance was missing. Backend DELETE /brokers/:id
  // exists and is admin-only; parent supplies the handler + optimistic
  // pruning. Confirmation via the styled ConfirmDialog hook.
  const handleDeleteClick = async () => {
    if (!onDelete) return;
    const ok = await confirm({
      title: t('screens.brokers.confirmDeleteTitle', { defaultValue: 'Delete broker?' }),
      message: t('screens.brokers.confirmDelete', {
        defaultValue: `"${b.name}" will be permanently removed. This cannot be undone.`,
        name: b.name,
      }),
      confirmText: t('common.delete', { defaultValue: 'Delete' }),
      variant: 'danger',
    });
    if (ok) onDelete();
  };
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button
          onClick={() => setSelectedBroker(null)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 34,
            height: 34,
            borderRadius: 8,
            border: `1px solid ${S.borderLight}`,
            background: '#fff',
            cursor: 'pointer',
          }}
        >
          <Icon name='arrowLeft' color={S.textSecondary} size={16} />
        </button>
        <div>
          <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
            {t('screens.brokers.administration', { defaultValue: 'Administration' })} {Icons.chevronRight(S.textMuted, 12)} {t('screens.brokers.brokersCrumb', { defaultValue: 'Brokers' })} {Icons.chevronRight(S.textMuted, 12)}
            <span style={{ color: S.textPrimary, fontWeight: 500 }}>{b.name}</span>
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, color: S.textPrimary }}>{b.name}</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <StatusBadge status={b.status} />
        <BtnPrimary
          onClick={() => {
            setShowAddForm(true);
            // Every field the form can edit must be seeded here, or opening
            // Edit and saving would blank whatever the form does not carry.
            setNewBroker({
              name: b.name, contact: b.contact, email: b.email, phone: b?.phone || '',
              address: b?.address || '', postalCode: b?.postalCode || '',
              city: b.city, canton: b.canton,
              // NOT `b.commPlan` raw: the mapper used to substitute '—' for a
              // missing plan, which the form then seeded and the PATCH stored,
              // writing an em dash into the record. The mapper no longer
              // substitutes; the two display sites do their own fallback.
              commPlan: b?.commPlan || '',
              registrationAuthority: b?.registrationAuthority || '',
              registrationNumber: b?.registrationNumber || '',
            });
          }}
        >
          <Icon name='edit' color='#fff' size={15} /> {t('screens.brokers.editBroker', { defaultValue: 'Edit Broker' })}
        </BtnPrimary>
        {onDelete && (
          <button
            type='button'
            onClick={handleDeleteClick}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '8px 16px',
              borderRadius: 8,
              border: '1px solid #dc2626',
              background: '#fff',
              color: '#dc2626',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            <Icon name='trash' color='#dc2626' size={14} /> {t('screens.brokers.deleteBroker', { defaultValue: 'Delete' })}
          </button>
        )}
      </div>
      {ConfirmPortal}
    </header>
  );
};

export default Header;
